export const ProgramPages = {
    LIVE: "LIVE",
    SPORTS: "SPORTS",
    ADULT: "ADULT",
} as const;

export type ProgramPage = typeof ProgramPages[keyof typeof ProgramPages];

